<template>
  <b-form @submit.prevent="submit">
    <validation-observer ref="phoneForm">
      <b-row>
        <b-col md="4">
          <validation-provider
            #default="{ errors }"
            name="Phone"
            rules="required"
          >
            <b-form-group
              label="Phone"
            >
              <b-form-input
                v-model="formData.phone_number"
                :readonly="formData.is_populated"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="4">
          <b-form-group
            label="Status"
            label-for="status"
          >
            <b-form-select
              id="status"
              v-model="formData.status"
              :options="statuses"
              :disabled="!data"
            />
          </b-form-group>
        </b-col>

        <b-col
          md="4"
          class="d-flex align-items-center"
        >
          <b-button
            v-show="$can('write', 'users')"
            variant="primary"
            type="submit"
            :disabled="submitting"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Submit</span>
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
    <hr>
  </b-form>
</template>

<script>
import {
  BForm, BRow, BCol, BFormInput, BFormSelect, BFormGroup, BButton, BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { reactive, ref } from '@vue/composition-api'

export default {
  components: {
    BForm, BRow, BCol, ValidationProvider, ValidationObserver, BFormInput, BFormSelect, BFormGroup, BButton, BSpinner,
  },
  props: {
    data: {
      type: Object,
      default: undefined,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  setup(props, ctx) {
    const statuses = [
      {
        text: 'Eligible',
        value: 'ELIGIBLE',
        disabled: true,
      },
      {
        text: 'Pending',
        value: 'PENDING',
      },
      // {
      //   text: 'Rejected',
      //   value: 'REJECTED',
      // },
      {
        text: 'Approved',
        value: 'APPROVED',
      },
      // {
      //   text: 'Deleted',
      //   value: 'DELETED',
      // },
    ]
    const phoneForm = ref(null)
    const submitting = ref(false)
    const formData = reactive({
      phone_number: null,
      status: 'PENDING',
      is_populated: (props.data && !props.data.newPhone),
    })
    if (props.data && !props.data.newPhone) {
      Object.keys(props.data).forEach(k => {
        formData[k] = props.data[k]
      })
    }
    const submit = async () => {
      const valid = await phoneForm.value.validate()
      if (!valid) return
      submitting.value = true
      try {
        const body = {
          id: props.user.id,
          device_id: formData.device_id,
          phone_number: formData.phone_number,
          data: formData,
        }
        if (!props.data.newPhone) {
          await ctx.root.$store.dispatch('users/patchUserPhoneInfo', body)
        } else {
          await ctx.root.$store.dispatch('users/createUserPhoneInfo', body)
        }
        ctx.emit('submitted')
      } catch (error) {
        console.log(error.response)
      } finally {
        submitting.value = false
      }
    }
    return {
      required,
      statuses,
      formData,
      phoneForm,
      submit,
      submitting,
    }
  },
}
</script>
